




































































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class MySQLIntegration extends Vue {
  @Prop() private integrationDetails!: any;
}
